const trimTrailingSlashes = (url) => (url || "").replace(/\/+$/, "");

export const getBackendBaseUrl = () => {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv && fromEnv.trim().length > 0) return trimTrailingSlashes(fromEnv);

  const isDev = process.env.NODE_ENV === "development";
  return isDev ? "http://localhost:58794" : "https://api.lumos.edu";
};

export const getIntuitPaymentsBaseUrl = () => {
  const fromEnv = process.env.REACT_APP_INTUIT_PAYMENTS_BASE_URL;
  if (fromEnv && fromEnv.trim().length > 0) return trimTrailingSlashes(fromEnv);

  const env = (process.env.REACT_APP_INTUIT_PAYMENTS_ENV || "").toLowerCase();
  if (env === "production" || env === "prod") return "https://api.intuit.com";
  if (env === "sandbox" || env === "sbx") return "https://sandbox.api.intuit.com";

  // Padrão seguro: sandbox em dev, produção em produção (configurável via env).
  const isDev = process.env.NODE_ENV === "development";
  return isDev ? "https://sandbox.api.intuit.com" : "https://api.intuit.com";
};

